import ViewBase from '../../view-base.view';
import aiJpoModel from '../../../models/schedule/ai-jpo.model';
import languageModel from '../../../models/language.model';
import paginationComponent from '../../../components/pagination/pagination.component';

export default function ShopListTabView() {
    ViewBase.call(this);

    let shops = [];
    let totalCount = 0;
    let pageIndex = 1;
    let pageSize = 10;
    let filter = {};

    const DEFAULT_PAGE_SIZE = 10;

    let loadShops = () => {
        this.showLoading();
        aiJpoModel.getShops({
            countryCode: filter.countryCode,
            bu: filter.bu,
            month: filter.month,
            page: pageIndex,
            pageSize: pageSize
        })
            .then((result) => {
                shops = result.items || [];
                totalCount = result.total || 0;
            })
            .catch((error) => {
                this.handleError(error);
            })
            .finally(() => {
                this.hideLoading();
            });
    };

    let onPageChanged = (p) => {
        pageIndex = p;
        loadShops();
    };

    let onPageSizeChanged = (p, ps) => {
        pageIndex = p;
        pageSize = ps;
        loadShops();
    };

    return {
        oninit: ({ attrs }) => {
            filter = attrs.filter;
            loadShops();
        },
        onupdate: ({ attrs }) => {
            if (attrs.searchVersion !== filter._searchVersion) {
                filter = attrs.filter;
                filter._searchVersion = attrs.searchVersion;
                pageIndex = 1;
                loadShops();
            }
        },
        view: () => {
            return [
                m('.card',
                    m('.card-body',
                        m('.d-flex.justify-content-end.mb-2',
                            m('a.btn.btn-primary', {
                                onclick: () => {
                                    // CSV export
                                    const header = ['Store Code', 'Latitude', 'Longitude', 'Grade'];
                                    const rows = shops.map(s => [s.storeCode, s.latitude, s.longitude, s.grade]);
                                    const csv = [header, ...rows].map(r => r.map(c => `"${String(c ?? '').replace(/"/g, '""')}"`).join(',')).join('\r\n');
                                    const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
                                    const a = document.createElement('a');
                                    a.href = URL.createObjectURL(blob);
                                    a.download = `shop-list_${new Date().toISOString().slice(0, 10)}.csv`;
                                    a.click();
                                }
                            },
                                m('i.bi.bi-file-earmark-arrow-down-fill'),
                                languageModel.getText('', 'Excel Download')
                            )
                        ),
                        m('.table-responsive',
                            m('table.table.table-bordered',
                                m('thead.thead-bggrey',
                                    m('tr.align-middle', [
                                        m('th', { scope: 'col' }, languageModel.getText('', 'Store Code')),
                                        m('th', { scope: 'col', style: 'width: 130px;' }, languageModel.getText('', 'Latitude')),
                                        m('th', { scope: 'col', style: 'width: 130px;' }, languageModel.getText('', 'Longitude')),
                                        m('th', { scope: 'col', style: 'width: 100px;' }, languageModel.getText('', 'Grade')),
                                    ])
                                ),
                                m('tbody',
                                    shops.length === 0 &&
                                        m('tr.align-middle',
                                            m('td', { colspan: '4' }, languageModel.getText('', 'No records found.'))
                                        ),
                                    shops.map((s) =>
                                        m('tr', [
                                            m('td', s.storeCode),
                                            m('td.text-end', s.latitude != null ? Number(s.latitude).toFixed(6) : ''),
                                            m('td.text-end', s.longitude != null ? Number(s.longitude).toFixed(6) : ''),
                                            m('td.text-center',
                                                m('span.ai-jpo-grade.ai-jpo-grade-' + (s.grade || '').toLowerCase(), s.grade || '')
                                            ),
                                        ])
                                    )
                                )
                            )
                        ),
                        !this._isLoading &&
                            m('.px-3.pt-2',
                                m(paginationComponent, {
                                    currentPage: pageIndex,
                                    pageSize: pageSize,
                                    totalItems: totalCount,
                                    onPageChanged: onPageChanged,
                                    onPageSizeChanged: onPageSizeChanged
                                })
                            )
                    )
                )
            ];
        }
    };
}
